import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoadingModule } from '../../../../shared/ui/loading/loading.module'
import { AttachmentTypeScanDataModule } from '../../components/attachment-type-scan-data/attachment-type-scan-data.module'
import { EditScanDialogComponent } from './edit-scan-dialog.component'

@NgModule({
    declarations: [EditScanDialogComponent],
    exports: [EditScanDialogComponent],
    imports: [
        CommonModule,
        LoadingModule,
        AttachmentTypeScanDataModule,
    ],
})
export class EditScanDialogModule {}
